<template>
    <div>
        <div style="display:flex;flex-direction: row;justify-content: flex-end">
            <a-input
                style="width:20vw;margin-right:10px"
                addonBefore="记录日期"
                placeholder="请输入日期"
                v-model="logDate"/>
            <a-input
                style="width:20vw;"
                addonBefore="用户姓名"
                placeholder="请输入用户姓名"
                v-model="userName"/>
            <a-button
                type="primary"
                style="margin-left:16px;"
                icon="search"
                @click="()=>{this.pagination.current = 1;fetch()}">查询</a-button>
        </div>
        <j-table
            :tableColumns="columns"
            :tableData="tableData"
            :loading="loading"
            :tablePagination="pagination"
            v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;fetch(); }"
            v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;fetch(); }"
            style="margin-top:20px"
        />
    </div>
</template>
<script>
import JTable from "../../components/JTable"
const columns = [
    { title: '用户姓名', dataIndex: 'user_name', key: 'user_name', align:'center', fixed:'left'},
    { title: '操作', dataIndex: 'control', key: 'control', align:'center', width:220},
    { title: '操作描述', dataIndex: 'control_desc', key: 'control_desc', align:'center', },
    { title: '记录日期', dataIndex: 'log_date', key: 'log_date', align:'center', },
    { title: '记录时间', dataIndex: 'log_time', key: 'log_time', align:'center', },
    { title: '主机地址', dataIndex: 'host_ipport', key: 'host_ipport', align:'center',width:200 },
    { title: '市', dataIndex: 'log_city', key: 'log_city', align:'center', },
    { title: '区', dataIndex: 'log_district', key: 'log_district', align:'center', },
    { title: '省', dataIndex: 'log_province', key: 'log_province', align:'center', },
    { title: '操作流水', dataIndex: 'opr_ssn', key: 'opr_ssn', align:'center', width:300},
    { title: '用户ID', dataIndex: 'user_id', key: 'user_id', align:'center',width:300 },
]
export default {
    name: 'ServiceLogs',
    components:{
        JTable,
    },
    data(){
        return{
            orgId: this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
            logDate:'',
            userName:'',
            columns,
            tableData:[],
            loading:false,
            pagination:{
                current:1,
                total:0,
                pageSize:10,
                pageSizeOptions:['10','20','50']
            },
            orderby:'log_date desc',
        }
    },
    created(){
        this.fetch();
    },
    methods:{
        fetch(){
            const that = this;
            that.loading = true;
            that.tableData = [];
            const reqData  = {
                currpage: that.pagination.current,
                log_date: that.logDate,
                orderby: that.orderby,
                org_id: that.orgId,
                recnumperpage: that.pagination.pageSize,
                user_name: that.userName,
            }
            that.$http.post(
                that.$marco.api.operationlog,
                reqData,
                data => {
                    this.$log.success(JSON.stringify(data));
                    that.loading = false;
                    that.tableData = that.tableData.concat(data.pagelist);
                    that.pagination.total = data.recnum;

                },
                errorDesc => {
                    this.$log.normal(JSON.stringify(errorDesc));
                },
                error => {
                    this.$log.error('11111'+JSON.stringify(error));
                },
                that
            );
        }
    }
}
</script>
<style>
</style>